export default __webpack_public_path__ + "static/media/picture-2.36be7d90.png";